module.exports = __webpack_public_path__ + "static/background-e66805d72d19542b3a703aa84fe3d085.mp3";